// components
import {
  StyledBoxFlexCenterWrapFullWidth,
  StyledBoxFlexColumnSmallGapHalfWidth,
  StyledFlexGrowBox
} from 'components/shared/Box/Box.styles';
import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import { ControlledTextField } from 'components/shared/ControlledFields';

// hooks
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

// styles
import {
  StyledHalfWidthTypography,
  StyledSecondaryTitleTypography
} from './SpecialLeaveFields.styles';

// types
import { FormValues } from './SpecialLeaveTab.types';
import { FteSectionProps } from './SpecialLeaveFields.types';

const ControlledTextFieldWithReadMode = withReadModeField(ControlledTextField);

const FteSection = ({ customPlbName }: FteSectionProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla.specialLeave.settings'
  });
  const { t: tCommon } = useTranslation('common');
  const { control } = useFormContext<FormValues>();

  return (
    <>
      <StyledSecondaryTitleTypography variant="h6">
        {t('fte.title')}
      </StyledSecondaryTitleTypography>
      <StyledBoxFlexColumnSmallGapHalfWidth>
        <StyledBoxFlexCenterWrapFullWidth>
          <StyledHalfWidthTypography variant="body1">
            {t('fte.leaveHoursImportCode')}
          </StyledHalfWidthTypography>
          <StyledFlexGrowBox>
            <ControlledTextFieldWithReadMode
              control={control}
              name="specialLeaveFteLeaveHoursImportCode"
              variant="outlined"
              label={tCommon('costCenterDetail.importCode')}
              fullWidth
              disableLabel
            />
          </StyledFlexGrowBox>
        </StyledBoxFlexCenterWrapFullWidth>
        <StyledBoxFlexCenterWrapFullWidth>
          <StyledHalfWidthTypography variant="body1">
            {customPlbName
              ? t('fte.plbHoursImportCodeCustomName', {
                  customPlbName
                })
              : t('fte.plbHoursImportCode')}
          </StyledHalfWidthTypography>
          <StyledFlexGrowBox>
            <ControlledTextFieldWithReadMode
              control={control}
              name="specialLeaveFtePlbHoursImportCode"
              variant="outlined"
              label={tCommon('costCenterDetail.importCode')}
              fullWidth
              disableLabel
            />
          </StyledFlexGrowBox>
        </StyledBoxFlexCenterWrapFullWidth>
        <StyledBoxFlexCenterWrapFullWidth>
          <StyledHalfWidthTypography variant="body1">
            {t('fte.holidayCompensationImportCode')}
          </StyledHalfWidthTypography>
          <StyledFlexGrowBox>
            <ControlledTextFieldWithReadMode
              control={control}
              name="specialLeaveFteHolidayCompensationImportCode"
              variant="outlined"
              label={tCommon('costCenterDetail.importCode')}
              fullWidth
              disableLabel
            />
          </StyledFlexGrowBox>
        </StyledBoxFlexCenterWrapFullWidth>
      </StyledBoxFlexColumnSmallGapHalfWidth>
    </>
  );
};

export default FteSection;
